<template>
  <li :class="loadDecorated.day">
    <a href="#" class="move" v-if="canBeMoved">
      <i class="fa fa-bars"></i>
    </a>
    <form :data-vv-scope="validationScope">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-xs-6 col-sm-4 col-lg-2">
              <p class="material-details">
                <strong>Load ID</strong><br>
                {{ load.reference_number ? load.reference_number : '–' }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-4 col-xl-2 form-group" :class="{ 'has-error': errors.has('loading_date', validationScope) }">
              <p class="material-details">
                <strong :class="{ 'text-danger': errors.has('loading_date', validationScope) }">Loading Date</strong>
                <date-range
                  v-model="loadingDate"
                  :max-date="deliveryDateAsMoment"
                  :single-date-picker="true"
                  opens="right"
                  drops="up"
                  placeholder="00/00/0000"
                  name="loading_date">
                </date-range>
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Loading Time</strong><br>
                <flat-pickr class="form-control" v-model="loadingTime" :config="flatPickerConfig"  placeholder="9:00 AM"></flat-pickr>
                <!--<input type="text" class="form-control" v-model="loadingTime" placeholder="9am">-->
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Delivery Date</strong>
                <date-range
                  v-model="deliveryDate"
                  :min-date="loadingDateAsMoment"
                  :single-date-picker="true"
                  opens="right"
                  drops="up"
                  placeholder="00/00/0000"
                  name="delivery_date">
                </date-range>
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Delivery Time</strong>
                <flat-pickr class="form-control" v-model="deliveryTime" :config="flatPickerConfig" placeholder="11:00 AM"></flat-pickr>
                <!--<input type="text" class="form-control" v-model="deliveryTime" placeholder="11am to 3pm">-->
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2 form-group">
              <p class="material-details">
                <strong>Load Size</strong>
              </p>
              <div class="input-group">
                <input type="text" class="form-control" v-model="loadSize">
                <span class="input-group-addon">/t</span>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>
                  Rate
                  <span
                    :class="{ 'text-success': isProfitableLoadForArrow, 'text-danger': isNotProfitableLoadForArrow }"
                    :title="perTonneDifference">
                    {{ arrowProfitAsMoney }}
                  </span>
                </strong>
              </p>
              <div class="input-group">
                <span class="input-group-addon">$</span>
                <input type="text" class="form-control" v-model="rate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-8 col-xl-4 form-group" :class="{ 'has-error': errors.has('carrier', validationScope) }">
              <p class="material-details">
                <strong :class="{ 'text-danger': errors.has('carrier', validationScope) }">Company</strong>
                <selectize
                  name="carrier"
                  v-model="carrier"
                  :options="carrierOptions"
                  :fetch-results="fetchCarrierResults"
                  placeholder="–">
                </selectize>
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Rego</strong>
                <selectize
                  name="truck"
                  v-model="truck"
                  :options="truckOptions"
                  :disabled="noCarrierSelected"
                  :fetch-results="fetchTruckResults"
                  placeholder="–">
                </selectize>
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Driver</strong>
                <selectize
                  name="driver"
                  v-model="driver"
                  :options="driverOptions"
                  :disabled="noTruckSelected"
                  :fetch-results="fetchDriverResults"
                  placeholder="–">
                </selectize>
              </p>
              <span v-if="hasDevice" class="help-block device-help-block">Driver will be notified</span>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2">
              <p class="material-details">
                <strong>Configuration</strong>
                <selectize
                  name="configuration"
                  v-model="truckConfiguration"
                  :options="configurationOptions"
                  :disabled="noTruckSelected"
                  placeholder="–">
                </selectize>
              </p>
            </div>
            <div class="col-xs-6 col-sm-4 col-xl-2" v-show="isPlannedLoad">
              <p class="material-details">
                <strong>Status</strong><br>

                <span class="text-info" v-if="requestWasSent">Request Sent</span>
                <span class="text-danger" v-else-if="requestWasDeclined">Request Declined</span>
                <span class="text-info" v-else-if="isPlannedLoad">Planning</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-lg-10">
              <p class="material-details">
                <strong>Driver Notes</strong><br>
                <textarea class="form-control" v-model="notes"></textarea>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="row">
            <div class="col-lg-12">
              <div class="btn-toolbar pull-right">

                <ladda-button
                  :disabled="aboutToBeUpdated"
                  v-if="canDeleteLoad"
                  :on-click="handleDeleteLoad"
                  type="danger"
                  class="btn btn-circle-sm"
                  title="Delete Load">
                  <i class="fa fa-fw fa-trash-alt"></i>
                </ladda-button>

                <ladda-button
                  :disabled="aboutToBeUpdated"
                  v-if="canDuplicateLoad"
                  :on-click="handleDuplicateLoad"
                  type="info"
                  class="btn btn-circle-sm"
                  title="Duplicate Load">
                  <i class="far fa-copy"></i>
                </ladda-button>

                <ladda-button
                  :disabled="aboutToBeUpdated"
                  v-if="canRequestLoad"
                  :on-click="handleSendRequest"
                  type="info"
                  class="btn btn-circle-sm"
                  title="Send Load Request">
                  <i class="fas fa-paper-plane"></i>
                </ladda-button>

                <ladda-button
                  :disabled="aboutToBeUpdated"
                  v-if="canConfirmLoad"
                  :on-click="handleConfirmLoad"
                  type="info"
                  class="btn btn-circle-sm"
                  title="Confirm Load">
                  <i class="fa fa-fw fa-check"></i>
                </ladda-button>

                <ladda-button
                  :disabled="aboutToBeUpdated"
                  v-if="canAddToLoadPlan"
                  :on-click="handleAddToPlan"
                  type="info"
                  class="btn btn-circle-sm"
                  title="Add to Plan">
                  <i class="fa fa-fw fa-plus"></i>
                </ladda-button>
              </div>
            </div>
          </div>
          <div class="row">
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
              <div class="col-lg-12 text-right" v-show="changesSaved">
                <div class="margin-20"></div>
                <span class="text-success"><i class="fa fa-check"></i> Changes Saved</span>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </form>
  </li>
</template>

<script>
  import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
  import { SET_LOAD_ATTRIBUTE, REMOVE_LOAD, ADD_LOAD, SET_JOB_ATTRIBUTE } from 'vx/mutations'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { clone, map, debounce, find, get } from 'lodash'
  import { stateMapper, loadHelpers } from 'mixins/loads'
  import flatPickr from 'vue-flatpickr-component'
  import { LoadDecorator } from 'decorators'
  import moment from 'moment'
  import { notify } from 'utils'

  export default {
    mixins: [stateMapper, loadHelpers],
    props: ['load', 'defaultCarriers'],

    components: {
      DateRange,
      Selectize,
      LaddaButton,
      flatPickr
    },

    created () {
      this.setupDefaults()

      this.changesSaved = false

      this.debounceChangesSaved = debounce(this.debounceChangesSaved, 2500)

      this.$nextTick(() => {
        this.$watch('load', this.debounceUpdateLoad, { deep: true })
        this.$watch('carrier', this.fetchTrucksAndDriversForCarrier)
        this.$watch('truck', this.prefillTruckDriverAndConfiguration)
      })
    },

    data () {
      return {
        carriers: [],
        trucks: [],
        drivers: [],
        configurationOptions: [],
        changesSaved: false,
        updatingLoadTimeout: null,
        updatingNotRequired: false,
        flatPickerConfig: {
          altFormat: 'h:i K',
          altInput: true,
          enableTime: true,
          noCalendar: true,
          dateFormat: 'h:i K'
        }
      }
    },

    computed: {
      ...mapState('job', ['job']),
      ...mapGetters('job/plannedLoads', ['nextPlannedLoadOrder']),

      deliveryDateAsMoment () {
        if (this.deliveryDate) {
          return moment(this.deliveryDate, 'DD/MM/YYYY')
        }

        return null
      },

      loadingDateAsMoment () {
        if (this.loadingDate) {
          return moment(this.loadingDate, 'DD/MM/YYYY')
        }

        return null
      },

      /**
       * Carrier options.
       *
       * @return array
       */
      carrierOptions () {
        return map(this.carriers, carrier => ({ id: carrier.id, text: carrier.profile.company_name }))
      },

      /**
       * Truck options.
       *
       * @return array
       */
      truckOptions () {
        return map(this.trucks, truck => ({ id: truck.id, text: truck.registration }))
      },

      /**
       * Driver options.
       *
       * @return array
       */
      driverOptions () {
        return map(this.drivers, driver => (driver ? { id: driver.id, text: `${driver.profile.full_name}` } : {}))
      },

      /**
       * Validation scope for the load.
       *
       * @return string
       */
      validationScope () {
        return `load-${this.load.id}`
      },

      /**
       * Decorate the local state load.
       *
       * @return LoadDecorator
       */
      loadDecorated () {
        return new LoadDecorator(this.load)
      },

      /**
       * Determines if the load is about to be updated.
       *
       * @return boolean
       */
      aboutToBeUpdated () {
        return this.updatingLoadTimeout !== null
      },

      /**
       * Determine if the load can be added to the plan.
       *
       * @return boolean
       */
      canAddToLoadPlan () {
        return this.load.id === null
      },

      /**
       * Determine if we can duplicate the load.
       *
       * @return boolean
       */
      canDuplicateLoad () {
        return this.isPlannedLoad
      },

      /**
       * Determine if we can send a load request.
       *
       * @return boolean
       */
      canRequestLoad () {
        // admin can resend request to carrier, so we disable the request_sent check here
        return this.isPlannedLoad // && this.load.request_sent === false
      },

      /**
       * Determine if we can delete the load.
       *
       * @return boolean
       */
      canDeleteLoad () {
        return this.isPlannedLoad
      },

      /**
       * Determine if we can confirm the load.
       *
       * @return boolean
       */
      canConfirmLoad () {
        // admin can resend request to carrier, so we disable the request_sent check here
        return this.isPlannedLoad // && this.load.request_sent === false
      },

      /**
       * Determine if we can move the load.
       *
       * @return boolean
       */
      canBeMoved () {
        return this.isPlannedLoad
      },

      /**
       * Determine if the load is planned.
       *
       * @return boolean
       */
      isPlannedLoad () {
        return this.load.id !== null && this.load.status === 'planned'
      },

      /**
       * Determine if a request has been sent to the carrier.
       *
       * @return boolean
       */
      requestWasSent () {
        return this.isPlannedLoad && this.load.request_sent === true
      },

      /**
       * Determine if a request has been sent to the carrier and it was declined.
       *
       * @return boolean
       */
      requestWasDeclined () {
        return this.isPlannedLoad && this.load.request_declined === true
      },

      /**
       * Determine if no carrier is selected.
       *
       * @return boolean
       */
      noCarrierSelected () {
        return this.carrier === null
      },

      /**
       * Determine if no truck is selected.
       *
       * @return boolean
       */
      noTruckSelected () {
        return this.truck === null
      },

      /**
       * Determine if  if the selected driver has a device
       */
      hasDevice () {
        if (this.driver) {
          let loadDriver = find(this.drivers, driver => {
            return driver.id === this.driver
          })

          if (loadDriver.devices.length > 0) {
            return true
          }
        }
        return false
      }
    },

    watch: {
      /**
       * Watch the default carriers for changes and push them down.
       *
       * @param object carriers
       *
       * @return void
       */
      defaultCarriers (carriers) {
        this.carriers = clone(carriers)
      },

      /**
       * Watch the loads order, if it changes, flag this, as we don't want to show
       * the changes saved message.
       */
      'load.order' (oldOrder, newOrder) {
        if (oldOrder !== newOrder) {
          this.updatingNotRequired = true
        }
      },

      /**
       * Watch changes saved and debounce the toggling.
       *
       * @return void
       */
      changesSaved () {
        this.debounceChangesSaved()
      }
    },

    methods: {
      ...mapActions('carrier', ['getCarriers']),
      ...mapActions('truck', ['getTrucks', 'getTruck']),
      ...mapActions('driver', ['getDrivers']),
      ...mapActions('load', ['storeLoad', 'deleteLoad', 'scheduleLoad', 'requestLoad', 'updateLoad']),
      ...mapActions('job/plannedLoads', ['addNewPlannedLoad']),
      ...mapMutations('job/plannedLoads', {
        SET_LOAD_ATTRIBUTE: SET_LOAD_ATTRIBUTE,
        removePlannedLoad: REMOVE_LOAD,
        addPlannedLoad: ADD_LOAD
      }),
      ...mapMutations('job', {
        SET_JOB_ATTRIBUTE: SET_JOB_ATTRIBUTE
      }),
      ...mapMutations('load', {
        addScheduledLoad: ADD_LOAD
      }),

      /**
       * Debounce the updating of the load.
       *
       * @param object newLoad
       * @param object oldLoad
       *
       * @return Promise
       */
      debounceUpdateLoad (newLoad, oldLoad) {
        clearTimeout(this.updatingLoadTimeout)

        if (oldLoad.id === null || oldLoad.id === undefined || this.updatingNotRequired) {
          this.updatingNotRequired = false

          return
        }

        this.updatingLoadTimeout = setTimeout(() => {
          return this.handleUpdateLoad().then(() => {
            this.changesSaved = true

            this.updatingLoadTimeout = null
          })
        }, 1250)
      },

      /**
       * Debounce the toggling of saved changes.
       *
       * @return void
       */
      debounceChangesSaved () {
        if (this.changesSaved) {
          this.changesSaved = false
        }
      },

      /**
       * Setup the defaults provided by the default load and default carriers props.
       *
       * @return void
       */
      setupDefaults () {
        this.carriers = clone(this.defaultCarriers)

        // For an existing load we can attempt to set the initial options for both the
        // driver and the truck to whatever they are set as on the load itself.
        if (this.isPlannedLoad) {
          if (this.load.carrier) {
            this.carriers.push(this.load.carrier)

            this.trucks = clone(this.load.carrier.trucks)
            this.drivers = clone(this.load.carrier.drivers)
          }

          if (this.load.truck) {
            this.trucks.push(this.load.truck)

            // With the loads truck we need to set the configuration options that will
            // be available for this specific truck.
            this.setTruckConfigurationOptions(this.load.truck)
          }

          if (this.load.driver) {
            this.drivers.push(this.load.driver)
          }
        }
      },

      /**
       * Fetch the trucks and drivers for the given carrier.
       *
       * @param integer id
       *
       * @return void
       */
      fetchTrucksAndDriversForCarrier (id) {
        // As soon as the carrier is changed we will reset the truck, this will flow on
        // to below and reset the driver and truck configuration.
        this.truck = null

        if (!id) {
          return
        }

        this.getTrucks({ user_id: id }).then(this.setTrucks)
        this.getDrivers({ user_id: id }).then(this.setDrivers)
      },

      /**
       * Prefill the truck driver and truck configuration for the given truck.
       *
       * @param integer id
       *
       * @return void
       */
      prefillTruckDriverAndConfiguration (id) {
        // As soon as the truck changes we reset the default driver and the configuration
        // of the truck so we can prefill with the selected trucks options.
        this.driver = null
        this.truckConfiguration = null
        this.configurationOptions = []

        if (!id) {
          return
        }

        const setDriverToTrucksPrimaryDriver = truck => {
          this.drivers.push(truck.driver)

          this.driver = truck.driver && truck.driver.id

          return truck
        }

        this.getTruck(id)
          .then(setDriverToTrucksPrimaryDriver)
          .then(this.setTruckConfigurationOptions)
      },

      /**
       * Set the configuration opens for the given truck.
       *
       * @param objec truck
       *
       * @return void
       */
      setTruckConfigurationOptions (truck) {
        this.configurationOptions = map(truck.configurations, configuration => {
          return { id: configuration.pivot_id, text: `${configuration.net_weight}t ${configuration.description}` }
        })
      },

      /**
       * Set the local trucks.
       *
       * @param array trucks
       *
       * @return void
       */
      setTrucks ({ data: { data: trucks } }) {
        this.trucks = clone(trucks)
      },

      /**
       * Set the local drivers.
       *
       * @param array drivers
       *
       * @return void
       */
      setDrivers ({ data: { data: drivers } }) {
        this.drivers = clone(drivers)
      },

      /**
       * Set the local carriers.
       *
       * @param array carriers
       *
       * @return void
       */
      setCarriers (carriers) {
        this.carriers = clone(carriers)
      },

      /**
       * Fetch more carrier results.
       *
       * @param string name
       * @param Function callback
       *
       * @return Promise
       */
      fetchCarrierResults (name, callback) {
        return this.getCarriers({ name }).then(response => {
          this.carriers = clone(response)
          callback(this.carrierOptions)
        })
      },

      /**
       * Fetch more truck results.
       *
       * @param string search
       * @param Function callback
       *
       * @return Promise
       */
      fetchTruckResults (search, callback) {
        return this.getTrucks({ user_id: this.carrier, search })
          .then(this.setTrucks)
          .then(callback.apply(this.truckOptions))
      },

      /**
       * Fetch more driver results.
       *
       * @param string name
       * @param Function callback
       *
       * @return Promise
       */
      fetchDriverResults (name, callback) {
        return this.getDrivers({ user_id: this.carrier, name })
          .then(this.setDrivers)
          .then(callback.apply(this.driverOptions))
      },

      /**
       * Update job public_quantity after a load has been scheduled
       *
       * @param object data
       * @return null
       */
      updatePublicQuantity (data) {
        const publicQuantity = get(data, 'job.public_quantity', undefined)
        if (publicQuantity !== undefined) {
          this[SET_JOB_ATTRIBUTE]({ attribute: 'public_quantity', value: publicQuantity })
        }
      },

      /**
       * Handle adding a load to the plan.
       *
       * @return Promise
       */
      handleAddToPlan () {
        return this.storeLoad({ job: this.job.id, payload: this.load }).then(({ data }) => {
          this.addNewPlannedLoad(data)

          this.updatePublicQuantity(data)
        })
      },

      /**
       * Handle duplicating a load.
       *
       * @return Promise
       */
      handleDuplicateLoad () {
        let payload = clone(this.load)

        payload.order = this.nextPlannedLoadOrder
        payload.request_sent = false

        return this.storeLoad({ job: this.job.id, payload }).then(({ data }) => {
          this.addPlannedLoad(data)

          this.updatePublicQuantity(data)

          this.resetEmptyLoadOrder()
        })
      },

      /**
       * Handle deleting a load.
       *
       * @return Promise
       */
      handleDeleteLoad () {
        const onError = error => {
          if (get(error, 'response.statusCode') === 422) {
            notify.error('Cannot delete a PAID load')
          }
        }

        return this.deleteLoad(this.load.id).then(({ data }) => {
          this.removePlannedLoad(this.load)

          this.updatePublicQuantity(data)

          this.resetEmptyLoadOrder()
        }).catch(onError)
      },

      /**
       * Handle updating a load.
       *
       * @return Promise
       */
      handleUpdateLoad () {
        const replaceWithResponse = ({ data }) => {
          this.updatingNotRequired = true

          this.addPlannedLoad(data)

          this.updatePublicQuantity(data)
        }

        return this.updateLoad({ id: this.load.id, payload: this.load }).then(replaceWithResponse)
      },

      /**
       * Confirm a load by scheduling it.
       *
       * @return Promise
       */
      handleConfirmLoad () {
        return this.validateLoadingDateAndCarrier().then(() => {
          return this.scheduleLoad(this.load.id).then(({ data }) => {
            this.removePlannedLoad(this.load)

            // After confirming a load the job will either be back to "in progress" or
            // "accepted" based on whether or not the job already has in progress
            // loads or if it has some completed tonnage.
            if (this.job.in_progress_loads_count > 0 || this.job.tonnage_completed > 0) {
              this[SET_JOB_ATTRIBUTE]({ attribute: 'status', value: 'in_progress' })
            } else {
              this[SET_JOB_ATTRIBUTE]({ attribute: 'status', value: 'accepted' })
            }

            this.updatePublicQuantity(data)

            this.addScheduledLoad(data)
          })
        })
      },

      /**
       * Handle sending the load request to the nominated carrier.
       *
       * @return Promise
       */
      handleSendRequest () {
        return this.validateLoadingDateAndCarrier().then(() => {
          return this.requestLoad(this.load.id).then(response => {
            this.addPlannedLoad(response.data)
          })
        })
      },

      /**
       * Validate the loading date and the carrier.
       *
       * @return Promise
       */
      validateLoadingDateAndCarrier () {
        this.attachRules('carrier', 'required', { scope: this.validationScope })
        this.attachRules('loading_date', 'required', { scope: this.validationScope })

        return this.validateScope(this.validationScope, {
          carrier: this.carrier,
          loading_date: this.loadingDate
        })
      },

      /**
       * Reset the empty loads order.
       *
       * Needs to be done after an add/delete.
       *
       * @return void
       */
      resetEmptyLoadOrder () {
        this[SET_LOAD_ATTRIBUTE]({ id: null, attribute: 'order', value: this.nextPlannedLoadOrder })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PlannedLoad.vue?4523fb82